import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewCheckbox", "manageCheckbox"]

  connect() {
    if (this.hasManageCheckboxTarget && this.hasViewCheckboxTarget) {
      if (
        this.manageCheckboxTarget.checked &&
        this.viewCheckboxTarget.checked
      ) {
        this.viewCheckboxTarget.classList.add(
          "opacity-40",
          "pointer-events-none",
        )
      }
    }
  }

  manageCheckboxChanged() {
    if (!this.hasViewCheckboxTarget) return

    if (this.manageCheckboxTarget.checked) {
      this.viewCheckboxTarget.checked = true
      this.viewCheckboxTarget.classList.add("opacity-40", "pointer-events-none")
    } else {
      this.viewCheckboxTarget.classList.remove(
        "opacity-40",
        "pointer-events-none",
      )
    }
  }

  viewCheckboxChanged() {
    if (!this.hasManageCheckboxTarget) return

    if (!this.viewCheckboxTarget.checked && this.manageCheckboxTarget.checked) {
      this.viewCheckboxTarget.checked = true
    }
  }
}
